// change position of desktop nested menu if scrolled
if (isScreenSizeLarge() && !$("body").hasClass("index")) {
    let previousOffset = $(document).scrollTop();
    let waitForMenuHeight;
    let menu = $(".nav-nested .parent");

    $(".header__menu-toggle").on("click touchstart", () => {
        resetMenuPosition();
    });

    $(window).on("scroll", () => {
        if ($(".header--search-focus").hasClass("is-header-sticky") || $(document).scrollTop() === 0) {
            if (!menu.children().hasClass("nav-nested__link--is-active")) {
                if (previousOffset > $(document).scrollTop() || previousOffset + menu.outerHeight(true) + 110 < $(document).scrollTop()) {
                    resetMenuPosition();
                }
            }            
        }
    });
       
    const updatePosition = (offset, topBarHeight) => {
        const footer = $(".footer__extra-content"),
            footerOffset = footer.length == 0 ? $(document).outerHeight() : footer.offset().top,
            maxOffset = footerOffset - menu.outerHeight(true) - 110;
        menu.css("top", `${Math.min(offset - topBarHeight, maxOffset)}px`);
        previousOffset = offset;
    }

    const resetMenuPosition = () => {
        clearInterval(waitForMenuHeight);
        let topBarHeight = 0;
        let offset = $(document).scrollTop();
        if (offset > 0) {
            topBarHeight = $("#shopify-section-announcement-bar").outerHeight() || 0;
        }
        if (menu.outerHeight(true) > 0) {
            updatePosition(offset, topBarHeight);
        } else {
            waitForMenuHeight = setInterval(() => {
                if (menu.outerHeight(true) > 0) {
                    clearInterval(waitForMenuHeight);
                    updatePosition(offset, topBarHeight);
                }
            }, 100);
        }
    }
}

// adjust position of desktop megamenu to align with top of screen or nested menu
function adjustMegaMenuPosition(element) {
    let navNestedTop = $(".nav-nested > .parent").offset().top,
        megaMenu = element.parent().children(".nav-nested__megamenu");

    if (megaMenu != undefined) {
        megaMenu.css("height", "auto")
        
        let megaMenuTop = element.offset().top,
            correction = navNestedTop - megaMenuTop,
            topAlign = $(document).scrollTop() - navNestedTop,
            header = $(".header--search-focus");

        if (header.hasClass("is-header-sticky") && !header.hasClass("slide-up")) {
            topAlign += header.innerHeight() - 5; // header is 5px off the screen
        }
        topAlign = Math.max(0, topAlign);
        correction += topAlign;

        // change height of small megamenu to align with bottom of menu item
        let bottomAlign = correction + megaMenu.innerHeight() - element.innerHeight();
        if (bottomAlign < 0) {
            let megaMenuHeight = megaMenu.innerHeight() + Math.abs(bottomAlign) + 1;
            megaMenu.css("height", `${megaMenuHeight}px`);
        }
        
        megaMenu.css("top", `${correction}px`);
    }
}

let menuLevelActive = 1;

function initMenu() {
   
   if (!isScreenSizeLarge()) {

        let previousMenuItem = "";

        $( ".nav-nested__link-parent > a" ).on( "click", function() {
            previousMenuItem = $(this).attr("data-title");
            // $(".nav-nested__back").html("< " + previousMenuItem);
            $(".nav-nested__back").attr("data-parent", "< " + previousMenuItem);
            $(".nav-nested__forward span").html(previousMenuItem);

            // Always scroll to top of the parent div so user can see the menu in all cases

            scrollToElementTop(".nav-nested > .parent");
        });

        $( ".nav-nested__link-child > a" ).on( "click", function() {
            previousMenuItem = $(this).attr("data-title");
            $(this).closest(".nav-nested__megamenu").find(".nav-nested__forward > span").html(previousMenuItem);
            $(this).closest(".nav-nested__megamenu").find(".nav-nested__forward").attr("href", $(this).attr("href"));

            // Always scroll to top of the parent div so user can see the menu in all cases

            scrollToElementTop(".nav-nested > .parent");
        });

        $( ".nav-nested__back" ).on( "click", function() {
            let previousItem = $(this).attr("data-parent").replace("< ", "");
            $(this).next().find("span").html(previousItem);
            $(this).next().attr("href", $(this).attr("data-parent-url"));
        });

        $( ".nav-nested__link--first > a, .nav-nested__back" ).on( "click", function() {

            if (menuLevelActive === 1) {

              const clickedItem = $( this ).parent();

              // Show or hide the second level of navigation

              Shopify.theme.mobileMenu.closeAllNestedLinkFirst();

              clickedItem.toggleClass("nav-nested__link--is-active");

              // Toggle main container

              if ( $(clickedItem).hasClass('nav-nested__link--is-active') ) {
                $(".nav-nested").addClass("nav-nested--active");
              } else {
                
                // Hide the menu alltogether

                Shopify.theme.mobileMenu.closeAllOtherNestedItemsOnMenu();
              };

              event.preventDefault();

              } else {
                $(".nav-nested__link-second").each(function(){
                    $(this).removeClass("nav-nested__link-child--is-active");
                    menuLevelActive = 1;
                 });
              }
        });

    } else {

        let timer;

        $('.nav-nested__link-parent > a').on({
            'mouseover': function () {
                let thisIsIt = $(this);

                timer = setTimeout(function () {
                    if ($("body").hasClass("index")) {
                        $('.nav-nested__overlay').css("display", "block");
                    }
                    $(".nav-nested__link-parent").each(function(){
                        $(this).removeClass("nav-nested__link--is-active");
                    });
                    thisIsIt.parent().addClass("nav-nested__link--is-active");
                    adjustMegaMenuPosition(thisIsIt);
                }, 500);
            },
            'mouseout' : function () {
                clearTimeout(timer);
            }
        });

        $( ".nav-nested__close" ).on( "click", function() {
            if ($("body").hasClass("index")) {
                $('.nav-nested__overlay').css("display", "none");
            }
            $(".nav-nested__link-parent").each(function(){
                $(this).removeClass("nav-nested__link--is-active");
            });
        });

        // Function to close 2nd lvl of mega menu when clicked outside of the menu
        $(document).on('click', function(evt) {
            if (!$(evt.target).hasClass('nav-nested__megamenu') && !$(evt.target).parents().hasClass('nav-nested__megamenu')) {
                if ($("body").hasClass("index")) {
                    $('.nav-nested__overlay').css("display", "none");
                }
                $(".nav-nested__link-parent").each(function(){
                    $(this).removeClass("nav-nested__link--is-active");
                });
            }
        })

        // Close mega menu after specified time out of the element
        $('.nav-nested__link-parent').on('mouseout', function(evt) {
            var closeMegaMenuAfterPeriod = setTimeout(closeMegaMenu, 1000);
            closeMegaMenuAfterPeriod
            $('.nav-nested__link-parent').on('mouseover', function(evt) {
                clearTimeout(closeMegaMenuAfterPeriod);
            })
        })

    }

};

function closeMegaMenu() {
    $(".nav-nested__link-parent").each(function(){
        $(this).removeClass("nav-nested__link--is-active");
    });
    if ($("body").hasClass("index")) {
        $('.nav-nested__overlay').css("display", "none");
    }
}

function isScreenSizeLarge() {
    if (Shopify.media_queries.large.matches) {
        return true;
    }
};

function resetMenu() {
    $(".nav-nested li").each(function(){
        $(this).removeClass("nav-nested__link-child--is-active");
        $(this).removeClass("nav-nested__link--is-active");
    });
    menuLevelActive = 1;
}

function changeLinkState () {
    if (!isScreenSizeLarge()) {

        // Display 3rd navigation level fo mobile menu

        $( ".nav-nested__link-second > a" ).on( "click", function() {

            $(this).parent().toggleClass("nav-nested__link-child--is-active");

            menuLevelActive = 3;

            // Don't allow click through on second level item

            event.preventDefault();
        });
    } else {
        $(".nav-nested__link-second").each(function(){
            $(this).removeClass("nav-nested__link-child--is-active");
         });
        $( ".nav-nested__link-second > a" ).off();
    }
}

$(window).ready(function(e) {
    sessionStorage.removeItem('scrolledDownMobileMenu');
    changeLinkState(e);
    initMenu(e);
});

$(window).resize(function(e) {
    $( ".nav-nested__link-second > a" ).off();
    $( ".nav-nested__link--first > a, .nav-nested__back" ).off();
    setNestedParentHeight();
    changeLinkState(e);
    initMenu(e);
});

$( ".nav-nested__overlay" ).on( "click", function() {
    resetMenu();

    if (!$("body").hasClass("index")) {
        $('body').removeClass('navigation-active');
        $('.header__menu-toggle').removeClass('is-active');
    }

    if (!isScreenSizeLarge()) {
        Shopify.theme.mobileMenu.close();
    }
});


// Set mobile navigation height to enable scrolling of the menu.


function setNestedParentHeight() {

    let viewportHeight = window.innerHeight;
    let nestedParentOffset = $(".nav-nested > .parent").offset();
    let nestedParentHeight = viewportHeight - nestedParentOffset.top;
    let isMobileMenuOn = $(".mobile-menu__toggle-button").attr("data-show-mobile-menu");

    // Set the correct mobile menu height so the user can scroll inside of it an all levels

    if (!Shopify.media_queries.large.matches) {
        $(".nav-nested > .parent").css("height", nestedParentHeight);
    }

    // Don't allow page scroll while the mobile menu is opened
    if (isMobileMenuOn === "true") {
        $("body, html").addClass("fixed-height-overflow");
    }

}

// Scroll to top of the menu every time user clicks on item to display another menu level

function scrollToElementTop(element) {
    $(element).animate({ scrollTop: 0 }, "fast");
}

// Set the mobile menu height every time is opened
$('.mobile-menu__toggle-button').on('click', function() {
    // Getting the position after the menu is already rendered
    const isMobileMenuOn = $('.mobile-menu__toggle-button').attr('data-show-mobile-menu');
    console.log(isMobileMenuOn);
    if (isMobileMenuOn === 'false') {
        setTimeout(setNestedParentHeight, 30);
    }
    const scrolledDown = $(document).scrollTop();
    sessionStorage.setItem('scrolledDownMobileMenu', scrolledDown);
});
